export const getFooterData = () => {
  const data = {
    benefits: "ASKESA@dc.gov",
    esaCallCenter: "(202) 727-5355",
    homelessServicesHotline: "(202) 399-7093",
  };
  return data;
};
